export default __webpack_public_path__ + "static/media/payment.39968e01.png";